import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { TButton } from '../../Key';
import { Heading } from '../KeyVless';

const PreviouslyMigratedTag = (date) => {
    // migrationHistory.filter((oldMigration) => oldMigration.to_server_comment === server.comment)[0].created_at

    const [timeSince, setTimeSince] = useState("");

    useEffect(() => {
        if (!date) return;
        const now = new Date();
        const target = new Date(date.date);
        const diffMs = now - target;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        if (diffDays < 14) {
            setTimeSince(`${diffDays} day${diffDays !== 1 ? "s" : ""} ago`);
        } else if (diffDays < 60) {
            const weeks = Math.floor(diffDays / 7);
            setTimeSince(`${weeks} week${weeks !== 1 ? "s" : ""} ago`);
        } else {
            const months = Math.floor(diffDays / 30);
            setTimeSince(`${months} month${months !== 1 ? "s" : ""} ago`);
        }
    }, [date]);
    return <span style={{ fontSize: '12px' }}>Previously {timeSince}</span>
}

export default function MigationPopup({
    keyID,
    reload,
    plan,
    close,
    currentServer,
    currentConfiguration,
    migrationHistory,
    currentSni,

    databaseRegion,
    databaseProvider,
}) {


    const [selectedPlan, setSelectedPlan] = useState('0');
    const [isLoading, setLoading] = useState(false);
    const [allServers, setAllServers] = useState([]);
    const [selectedServerTo, setSelectedServerTo] = useState('');

    const [selectedServerToObject, setSelectedServerToObject] = useState(null);
    const [filterValue, setFilterValue] = useState("");
    const isProcessingRequest = useRef(false);


    useEffect(() => {
        if (plan) {
            setSelectedPlan(String(plan));
        }
    }, [])

    // Supported on vless: ✅
    const getServers = async () => {
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setLoading(true)
        const request = await axios.post('https://sasovo.cdn-yandex.net/v4/vless/getListForUser', {
            region: databaseRegion,
            provider: databaseProvider
        }, { headers: { Authorization: `Bearer ${token}` } });
        const servers = request.data.keys;
        console.log({ servers });
        setAllServers(servers);

        const filteredServersByPlan = servers.filter((server) => parseInt(server.plan) === parseInt(selectedPlan) && server.enabled === true);
        setSelectedServerTo(filteredServersByPlan[0].id);
        setLoading(false);


    };

    useEffect(() => {
        getServers();
    }, []);

    // Supported on vless: ✅
    const migrateUsers = async (event) => {
        event.preventDefault();
        if (isProcessingRequest.current === true) {
            return;
        }
        if (isLoading) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        isProcessingRequest.current = true
        setLoading(true);


        if (keyID.length === 0) {
            return;
        }

        const data = {
            key: keyID,
            vless_server_id: selectedServerTo,
            is_delayed_migration: false,
        };

        const req = await axios.post('https://sasovo.cdn-yandex.net/v4/migrateUser/vless', data, { headers: { Authorization: `Bearer ${token}` } });
        if (req.data.ok) {
            reload();
        } else {
            alert('Something went wrong');
        }
        setLoading(false);
        isProcessingRequest.current = false;
    };

    useEffect(() => {
        if (allServers.length === 0) {
            return;
        }

        setSelectedServerTo(allServers.filter((server) => parseInt(server.plan) === parseInt(selectedPlan) && server.enabled === true)[0].id);
    }, [selectedPlan]);

    const shortenConfiguration = (configuration) => {
        try {

            if (configuration === undefined) {
                return "";
            }

            const portSplitting = configuration.split(":")[0];
            return portSplitting
        } catch (e) {
            return "";
        }
    }

    const shortenServerURL = (serverURL) => {
        try {
            if (serverURL === undefined) {
                return '';
            }
            const splitted = serverURL.split('//')[1];
            const portSplitting = splitted.split(":")[0];
            return portSplitting
        } catch (e) {
            try {
                const portSplitting = serverURL.split(":")[0];
                return portSplitting
            } catch (ee) {
                return ""
            }
        }
    }


    const getPlan = (plan) => {
        const n = parseInt(plan);
        if (n === 0) {
            return 'Базовый';
        }
        if (n === 1) {
            return 'Премиум';
        }
        if (n === 2) {
            return 'Deeplink';
        }
        if (n === 3) {
            return 'Семейный 6м';
        }
        if (n === 15) {
            return 'Семейный год';
        }
        if (n === 4) {
            return 'Базовый 🇬🇧';
        }
        if (n === 5) {
            return 'Базовый 🇫🇮';
        }
        if (n === 6) {
            return 'Базовый 🇩🇪';
        }
        if (n === 10) {
            return 'Базовый 🇺🇸';
        }
        if (n === 7) {
            return 'Базовый Yota';
        }
        if (n === 11) {
            return 'Семейный Yota';
        }
        if (n === 8) {
            return 'Семейный 🇬🇧';
        }
        if (n === 9) {
            return 'Семейный 🇫🇮';
        }
        if (n === 13) {
            return 'Семейный 🇩🇪';
        }
        if (n === 14) {
            return 'Семейный 🇺🇸';
        }
        if (n === 12) {
            return 'Russia';
        }
        if (n === 99) {
            return 'Триальный';
        }

        if (n === 20) {
            return 'Я в Китае';
        }
        if (n === 21) {
            return 'Я в Китае / 6м';
        }
        if (n === 30) {
            return 'Бизнес';
        }

        return '';
    };


    return (
        <div className="overlay">
            <form onSubmit={migrateUsers} className="overlay-content">
                <Heading icon={""} text={`Тариф: ${getPlan(plan)}`} />
                <div style={{ marginTop: '-30px' }} />
                <Heading icon={""} text={`Сервер: ${currentServer} | ${shortenConfiguration(currentConfiguration)} | ${currentSni}`} />
                <select className="t-input" type="text" value={selectedPlan} onChange={(e) => setSelectedPlan(e.target.value)}>
                    <option value={0}>Базовый</option>
                    <option value={3}>Семейный</option>
                    <option value={15}>Семейный / год</option>
                    <option value={1}>Премиум</option>
                    <option value={2}>Deeplink</option>
                    <option value={4}>Базовый / UK 🇬🇧</option>
                    <option value={5}>Базовый / Finland 🇫🇮</option>
                    <option value={6}>Базовый / Germany 🇩🇪</option>
                    <option value={10}>Базовый / USA 🇺🇸</option>
                    <option value={12}>Базовый / Rus 🇷🇺</option>
                    {/* <option value={7}>Базовый / Yota, Tele2</option> */}
                    <option value={8}>Семейный / UK 🇬🇧</option>
                    <option value={9}>Семейный / Finland 🇫🇮</option>
                    <option value={13}>Семейный / Germany 🇩🇪</option>
                    <option value={14}>Семейный / USA 🇺🇸</option>
                    {/* <option value={11}>Семейный / Yota, Tele2</option> */}
                    <option value={20}>1 Month / Я в Китае 🇨🇳</option>
                    <option value={21}>6 Month / Я в Китае 🇨🇳</option>
                    <option value={30}>Бизнес</option>
                </select>

                {selectedServerToObject === null ? <>
                    <input value={filterValue} onChange={e => setFilterValue(e.target.value)} type='text' className='t-input' placeholder='Label or IP Search'></input>
                    <div className='migration-server-select-container'>
                        {allServers
                            .filter((server) => parseInt(server.plan) === parseInt(selectedPlan) && server.enabled === true)
                            .filter((server) => server.comment.includes(filterValue) || server.key_url.includes(filterValue))
                            .map((server) => {
                                return (
                                    <div className='t-data-block server pointer break-text' onClick={() => {
                                        setSelectedServerToObject(server);
                                        setSelectedServerTo(server.id)
                                    }}>
                                        <div className='t-data-block-server'>
                                            <b>{server.is_proxy_enabled && '🧭'} {server.comment} | {shortenServerURL(server.key_url)}</b>
                                        </div>
                                        {server.sni}
                                        <div style={{ display: 'flex', flexDirection: 'row', gap: '4px' }}>
                                            {server.comment === currentServer && <span style={{ fontSize: '12px' }}>Текущий сервер</span>}
                                            {migrationHistory.filter((oldMigration) => oldMigration.to_server_comment === server.comment).length > 0 && <PreviouslyMigratedTag date={migrationHistory.filter((oldMigration) => oldMigration.to_server_comment === server.comment)[0].created_at} />}
                                            {server.match_by_region_and_provider && <span className='match-span'>💯</span>}
                                            {server.match_by_provider && <span className='match-span'>☎️</span>}
                                            {server.match_by_region && <span className='match-span'>🏡</span>}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                    <Heading icon={'📜'} text={'Предыдущие миграции'} />
                    <div className='migration-server-select-container'>
                        {migrationHistory.map((historyItem) => {
                            return <div className='t-data-block migration-item'><span style={{ color: "rgba(255, 255, 255, 0.5)", fontSize: '14px' }}>{new Date(historyItem.created_at).toLocaleString()}</span><br /> {historyItem.from_server_comment} → {historyItem.to_server_comment}</div>
                        })}
                    </div>
                </> : <div className='migration-server-select-container'>
                    <div className='t-label'>Выбранный сервер</div>
                    <div className='t-data-block pointer break-text' onClick={() => {
                        setSelectedServerToObject(null);
                        setSelectedServerTo("")
                    }}>
                        {selectedServerToObject.is_proxy_enabled && '🧭'} <b>{selectedServerToObject.comment}</b> {' | ' + selectedServerToObject.key_url}
                    </div>
                    <TButton onClick={() => {
                        setSelectedServerToObject(null);
                        setSelectedServerTo("")
                    }} text={"Сбросить сервер"}></TButton>
                </div>}

                <div className='t-data-double' style={{ paddingBottom: '40px' }}>
                    <TButton onClick={() => close()} text={"Отмена"} />
                    <TButton disabled={isLoading} text={isLoading ? "⏳ Крутим винтики..." : "Мигрировать"} />
                </div>
            </form>
        </div>
    );
}
